import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {z} from 'zod'
import {captureException} from '@sentry/react'
import {httpGetCancelReasons} from '../http/admin.http'
import {useAuthStore} from '@features/user/store/store'
import {raise} from '@utilities/helpers'

export const useCancelReasons = () => {
    const adminAccessToken = useAuthStore(state => state.adminAccessToken) ?? raise('adminAccessToken is nullish')
    return useQuery({
        queryKey: [QUERY_KEYS.CANCEL_REASON],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetCancelReasons({urlParams: {adminAccessToken}}),
                responseShape: z.array(
                    z.object({
                        key_name: z.string().min(1),
                        id: z.number()
                    })
                ),
                onZodError: captureException
            })
    })
}
